import { Link, useParams } from 'react-router-dom';
import { trendingArticles, categories } from '@/mocks/articles';

export default function RelatedArticles() {
  const { id } = useParams<{ id: string }>();
  const currentId = Number(id);

  // Get articles in same category excluding current
  const related = trendingArticles
    .filter((a) => a.id !== currentId)
    .slice(0, 5);

  return (
    <aside className="space-y-6">
      {/* Category Quick Links */}
      <div className="bg-background-100 rounded-lg p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3 flex items-center gap-2">
          <i className="ri-folder-2-line text-primary-500"></i>
          内容分类
        </h3>
        <div className="space-y-0.5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center justify-between px-3 py-2 rounded-md text-sm text-foreground-600 hover:text-primary-500 hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              <span className="flex items-center gap-2">
                <i className={`${cat.icon} text-xs`}></i>
                {cat.name}
              </span>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
            </Link>
          ))}
        </div>
      </div>

      {/* Related Articles */}
      <div className="bg-background-100 rounded-lg p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3 flex items-center gap-2">
          <i className="ri-article-line text-primary-500"></i>
          相关推荐
        </h3>
        <div className="space-y-3">
          {related.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex gap-3 group cursor-pointer"
            >
              <div className="w-16 h-16 rounded-md overflow-hidden shrink-0">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-700 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </p>
                <span className="text-foreground-400 text-xs mt-1 block">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Subscribe CTA */}
      <div className="bg-primary-500 rounded-lg p-5 text-center">
        <i className="ri-mail-send-line text-3xl text-background-50/80"></i>
        <h3 className="font-heading text-base font-semibold text-background-50 mt-3">
          追踪最新爆料
        </h3>
        <p className="text-background-50/70 text-xs mt-1 leading-relaxed">
          订阅911爆料网，第一时间获取网红黑料、明星塌房最新资讯
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-1.5 mt-4 px-4 py-2 bg-background-50 text-primary-500 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
        >
          订阅追踪
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>
    </aside>
  );
}